import React from "react"

import { type IconProps } from "./utils"

export default function BubbleMessage(props: IconProps) {
  return (
    <svg
      {...props}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.0001 3.33317C6.31818 3.33317 3.33341 6.31794 3.33341 9.99984C3.33341 11.0046 3.55515 11.9554 3.95158 12.8077C4.10839 13.1448 4.16579 13.5433 4.06904 13.9398L3.42017 16.599L6.19414 15.9726C6.57341 15.887 6.95218 15.9414 7.27561 16.0864C8.10633 16.4589 9.02784 16.6665 10.0001 16.6665C13.682 16.6665 16.6667 13.6817 16.6667 9.99984C16.6667 6.31794 13.682 3.33317 10.0001 3.33317ZM1.66675 9.99984C1.66675 5.39746 5.39771 1.6665 10.0001 1.6665C14.6025 1.6665 18.3334 5.39746 18.3334 9.99984C18.3334 14.6022 14.6025 18.3332 10.0001 18.3332C8.78824 18.3332 7.63469 18.074 6.5937 17.6072C6.57346 17.5981 6.56204 17.5985 6.56023 17.5986L3.78728 18.2248C2.58032 18.4973 1.50769 17.406 1.801 16.204L2.44961 13.5458C2.44975 13.5439 2.45028 13.5319 2.44037 13.5106C1.94365 12.4426 1.66675 11.2524 1.66675 9.99984Z"
        fill="currentColor"
      />
    </svg>
  )
}
